export default __webpack_public_path__ + "static/media/241-st-vincent-and-the-grenadines.4761960a.svg";